function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var RedMembership = function RedMembership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M2 12C2 6.486 6.486 2 12 2s10 4.486 10 10a9.98 9.98 0 0 1-3.253 7.375l-2.452-3.806c1.472-1.057 2.369-2.884 2.369-4.71 0-3.25-2.668-5.917-5.917-5.917H7.636a.25.25 0 0 0-.25.25v2.195H5.19a.25.25 0 0 0-.25.25v11.44A9.97 9.97 0 0 1 2 12m4.553 8.383q.404.263.833.487V8.998h-.833zm2.444 1.156c.948.3 1.957.461 3.003.461a10 10 0 0 0 3.195-.523l-5.547-8.593a.25.25 0 0 1 .21-.386h2.778c.973 0 1.861-.888 1.861-1.861a1.86 1.86 0 0 0-1.861-1.861H8.997zm7.705-.715q.39-.21.76-.45l-2.707-4.164-.667-1.111a.25.25 0 0 1 .127-.363c1.686-.632 2.837-2.21 2.837-3.988a4.21 4.21 0 0 0-4.194-4.195H8.997v.723h3.639a3.475 3.475 0 0 1 3.472 3.472 3.475 3.475 0 0 1-3.472 3.472h-.207zM0 12c0 6.617 5.383 12 12 12s12-5.383 12-12S18.617 0 12 0 0 5.383 0 12",
    clipRule: "evenodd"
  }));
};
export default RedMembership;